import React, { Component } from 'react';
import { HorizontalLine } from './HorizontalLine';
import {WidgetBlock} from './WidgetBlock';
import axios from 'axios';
import Cookies from 'universal-cookie'; 



export class Widgets extends React.Component {
    
    state = {
        items : []
        
    }
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        const cookies = new Cookies();
        axios.get(process.env.REACT_APP_BACKEND_SERVER + '/GetUserWidgetsInfo', {
                    headers: {
                    'Authorization': 'Bearer ' + cookies.get('tgsubs_token')
                    }
                }).then(res => {
                    //projects = res.data.projects
                   
                    
                    
                        this.setState( {
                            project_name: res.data[0].project_name,
                            items : res.data
                        });
                   
                    

                })
                .catch(err => {
                    console.log(err);
                    

                })
        
        
        
        
    }

    delete(alias, social) {
         
        const cookies = new Cookies();

        if (social == 'tg') {
            axios.post(process.env.REACT_APP_BACKEND_SERVER + '/DeleteTgWidget/',
            {
                alias : alias
            }, {
               headers: {
                   'Authorization': 'Bearer '+cookies.get('tgsubs_token')
               } // receive two parameter endpoint url ,form data 
       })
       .then(res => { // then print response status
            
           if (res.data.status == 'ok') {
               window.location.reload()
           }
       })
        }

        
        if (social == 'vk') {
            axios.post(process.env.REACT_APP_BACKEND_SERVER + '/DeleteVkWidget/',
            {
                alias : alias
            }, {
               headers: {
                   'Authorization': 'Bearer '+cookies.get('tgsubs_token')
               } // receive two parameter endpoint url ,form data 
       })
       .then(res => { // then print response status
            
           if (res.data.status == 'ok') {
               window.location.reload()
           }
       })
        }

    }

    render() {
        return (
            
                <div className='createPage'>
                        <h1> Созданные виджеты</h1>
                        <HorizontalLine />
                        <div className='pages_pagesBlock'>
                            
                            {
                                this.state.items.length > 0 ?
                            this.state.items.map(item => {
                                return (
                                    <WidgetBlock
                                    social={item.social} 
                                    confirmMsg = {"Вы уверены, что хотите удалить страницу и все статистические данные?"}
                                    delete={this.delete}
                                    alias = {item.alias}
                                    widget_name={item.widget_name}
                                    big_img_src={item.big_img_src} 
                                    cnt_sub={item.cnt_sub}
                                    total_views={item.total_views}
                                    is_active={true} />
                                );
                                })
                                :
                                <h3 className='notCreatedText'>Пока нет созданных виджетов</h3>
                                }
                        </div>
                
                </div>

            
                 
        )
    }
}